import React, { useEffect, useState } from 'react';

import { ExpiredInvite } from 'components/Invite/ExpiredInvite';
import { SignUpInvite } from 'components/Invite/SignUp/SignUpInvite';
import { SignUpLimitReachedInvite } from 'components/Invite/SignUpLimitReachedInvite';
import { UnexpectedTypeError } from 'lib/errors/UnexpectedTypeError';
import { hasServiceError } from 'lib/helpers/ServiceHelper';
import { LoadingPage } from 'lib/LoadingPage';
import { findInviteByUuid } from 'services/Invite.service';

import { InviteProps, LoadedInvite } from './invite.type';

export function Invite({ match: { params: { uuid }} }: InviteProps) {
    const [invite, setInvite] = useState<LoadedInvite | null>(null);
    const [isExpired, setIsExpired] = useState(false);
    const [isSignUpLimitReached, setIsSignUpLimitReached] = useState(false);

    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        const fetchInvite = async () => {
            setIsFetching(true);

            const response = await findInviteByUuid(uuid);

            if (hasServiceError(response))
                return hasServiceError(response);

            setInvite(response.invite);
            setIsExpired(response.isExpired);
            setIsSignUpLimitReached(response.isSignupLimitReached);

            setIsFetching(false);
        };

        fetchInvite();
    }, [uuid]);

    if (isFetching)
        return <LoadingPage tip="Buscando dados do convite..." />;

    if (isExpired)
        return <ExpiredInvite />;

    if (invite === null)
        throw new UnexpectedTypeError('invite', 'null', 'LoadedInvite');

    if (invite.apartment === null)
        throw new UnexpectedTypeError('invite.apartment', 'null', 'Apartment.Model');

    if (invite.author === null)
        throw new UnexpectedTypeError('invite.author', 'null', 'Resident.Model');

    if (isSignUpLimitReached)
        return <SignUpLimitReachedInvite />;

    return <SignUpInvite invite={invite} />;
}
